import {
  IconAlertCircle,
  IconBracesOff,
  IconBug,
  IconCategoryMinus,
  IconCloudOff,
  IconDatabase,
  IconError404,
  IconFile,
  IconFileMinus,
  IconFileUpload,
  IconLock,
  IconLockOpen,
  IconMessage2Bolt,
  IconOld,
  IconQuestionMark,
  IconShieldLockFilled,
  IconTriangleOff,
  IconUserX,
  IconWifiOff,
} from "@tabler/icons-react";
import { ERROR_TEXT, ErrorType, parseError } from "./Errors.ts";
import { JSX } from "react";
import { LOADING_CIRCLE } from "../../components/core/loading/LoadingCircle.tsx";

export const ERROR_ICON: Record<ErrorType, JSX.Element> = {
  UPLOAD_TIMEOUT: <IconCloudOff />,
  CHAT_INVALID: <IconMessage2Bolt />,
  CATEGORIES_NOT_FOUND: <IconQuestionMark />,
  ITEM_NOT_FOUND: <IconQuestionMark />,
  NETWORK: <IconWifiOff />,
  SESSION_EXPIRED: <IconShieldLockFilled />,
  PAYLOAD_MALFORMATTED: <IconBracesOff />,
  FETCH: <IconBug />, // network / unknown error
  LOGIN_INVALID: <IconUserX />, // invalid user credentials
  DATAPROTECTION_NOT_READ: <IconLock />, // privacy/lock related
  REGISTER_INVALID: <IconAlertCircle />, // general registration error
  FILE_UPLOAD: <IconFileUpload />, // uploading files
  FILE_DELETE: <IconFileMinus />, // deleting files
  ITEM_INVALID: <IconTriangleOff />, // item validation failed
  CATEGORY_INVALID: <IconCategoryMinus />, // category invalid
  CATEGORY_NOT_FOUND: <IconError404 />, // category missing
  SERVER_ERROR: <IconDatabase />, // backend/server error
  UNAUTHORIZED: <IconLockOpen />, // not authorized
  FILE_SIZE_LIMIT: <IconFile />, // file too big
  SINGLE_FILE_SIZE_LIMIT: <IconFile />, // single file too big
  FILE_AMOUNT_LIMIT: <IconFile />, // too many files
  OTP_EXPIRED: <IconOld />,
  LOADING: LOADING_CIRCLE,
  UNDEFINED: <IconBug />, // generic fallback
};

const ErrorMap = ({ error }: { error: unknown }) => {
  const parsed = parseError(error);
  return (
    <>
      {ERROR_ICON[parsed]}
      {ERROR_TEXT[parsed]}
    </>
  );
};
export default ErrorMap;
